import { render } from "./Equipment_delete_button.vue?vue&type=template&id=1a23da70&scoped=true"
import script from "./Equipment_delete_button.vue?vue&type=script&lang=js"
export * from "./Equipment_delete_button.vue?vue&type=script&lang=js"

import "./Equipment_delete_button.vue?vue&type=style&index=0&id=1a23da70&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a23da70"]])

export default __exports__